"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elasticsearch_api = void 0;

var _lsfastapiClient = require("@lsoft/lsfastapi-client");

var openapi = {
  openapi: "3.0.2",
  info: {
    title: "elasticsearch-api",
    version: "1.1.0"
  },
  paths: {
    "/elasticsearch/{index_name}/search": {
      get: {
        tags: ["elasticsearch"],
        summary: "Search Get",
        operationId: "elasticsearch__index_name__search_get",
        parameters: [{
          required: true,
          schema: {
            title: "Index Name",
            type: "string"
          },
          name: "index_name",
          "in": "path"
        }, {
          required: true,
          schema: {
            title: "Search String",
            type: "string"
          },
          name: "search_string",
          "in": "query"
        }, {
          required: false,
          schema: {
            title: "Skip",
            type: "integer",
            "default": 0
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            title: "Limit",
            type: "integer",
            "default": 12
          },
          name: "limit",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/elasticsearch/{index_name}/index": {
      put: {
        tags: ["elasticsearch"],
        summary: "Index Put",
        operationId: "elasticsearch__index_name__index_put",
        parameters: [{
          required: true,
          schema: {
            title: "Index Name",
            type: "string"
          },
          name: "index_name",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ElasticSearchIndexDocument"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/IndexPutResponse"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/elasticsearch/{index_name}/cache/documents": {
      get: {
        tags: ["elasticsearch"],
        summary: "Cache Documents Get",
        operationId: "elasticsearch__index_name__cache_documents_get",
        parameters: [{
          required: true,
          schema: {
            title: "Index Name",
            type: "string"
          },
          name: "index_name",
          "in": "path"
        }, {
          required: false,
          schema: {
            title: "Ids",
            type: "array",
            items: {
              type: "string"
            }
          },
          name: "ids",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ElasticSearchIndexDocumentsResponse"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  },
  components: {
    schemas: {
      ElasticSearchIndexDocument: {
        title: "ElasticSearchIndexDocument",
        required: ["id", "body"],
        type: "object",
        properties: {
          id: {
            title: "Id",
            type: "string"
          },
          body: {
            title: "Body",
            type: "object"
          }
        }
      },
      ElasticSearchIndexDocumentsResponse: {
        title: "ElasticSearchIndexDocumentsResponse",
        required: ["elasticsearch_index_documents"],
        type: "object",
        properties: {
          elasticsearch_index_documents: {
            title: "Elasticsearch Index Documents",
            type: "object",
            additionalProperties: {
              $ref: "#/components/schemas/ElasticSearchIndexDocument"
            }
          }
        }
      },
      HTTPValidationError: {
        title: "HTTPValidationError",
        type: "object",
        properties: {
          detail: {
            title: "Detail",
            type: "array",
            items: {
              $ref: "#/components/schemas/ValidationError"
            }
          }
        }
      },
      IndexPutResponse: {
        title: "IndexPutResponse",
        required: ["status"],
        type: "object",
        properties: {
          status: {
            $ref: "#/components/schemas/Status"
          }
        }
      },
      Status: {
        title: "Status",
        "enum": ["FAILED", "CREATED", "UPDATED", "SKIPPED"],
        type: "string",
        description: "An enumeration."
      },
      ValidationError: {
        title: "ValidationError",
        required: ["loc", "msg", "type"],
        type: "object",
        properties: {
          loc: {
            title: "Location",
            type: "array",
            items: {
              type: "string"
            }
          },
          msg: {
            title: "Message",
            type: "string"
          },
          type: {
            title: "Error Type",
            type: "string"
          }
        }
      }
    }
  }
};
var elasticsearch_api = (0, _lsfastapiClient.Api)(openapi);
exports.elasticsearch_api = elasticsearch_api;
//# sourceMappingURL=index.js.map